import React, { useState, useRef, useEffect } from "react";
import styles from "./styles/Faq.module.css";
import { useLanguage } from "../LanguageContext";

function FaqColumn({ data }) {
    const [activeIndex, setActiveIndex] = useState(-1);
    const refs = useRef([]);

    const toggleFAQ = (index) => {
        setActiveIndex((prevIndex) => (prevIndex === index ? -1 : index));
    };

    useEffect(() => {
        refs.current.forEach((ref, idx) => {
            if (ref) {
                ref.style.height = activeIndex === idx ? `${ref.scrollHeight}px` : "0px";
            }
        });
    }, [activeIndex]);

    return (
        <div className={styles.column}>
            {data.map((item, index) => (
                <div key={index} className={`${styles.faqItem} ${activeIndex === index ? styles.active : ""}`}>
                    <div className={styles.question} onClick={() => toggleFAQ(index)}>
                        <span dangerouslySetInnerHTML={{ __html: item.question }}></span>
                        <span className={styles.icon}>
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M16 9.14286H9.14286V16H6.85714V9.14286H0V6.85714H6.85714V0H9.14286V6.85714H16V9.14286Z" fill="#CFFB13" />
                            </svg>
                        </span>
                    </div>
                    <div ref={(el) => (refs.current[index] = el)} className={styles.answerWrapper}>
                        <div className={styles.answer} dangerouslySetInnerHTML={{ __html: item.answer }}></div>
                        {/* <div className={styles.answer} >{item.answer}</div> */}
                    </div>
                </div>
            ))}
        </div>
    );
}

function Faq() {
    const { t } = useLanguage();
    const items = t("faq.items");
    const title = t("faq.title");

    const midIndex = Math.ceil(items.length / 2);
    const leftColumn = items.slice(0, midIndex);
    const rightColumn = items.slice(midIndex);

    return (
        <div className={styles.faqContainer}>
            <h2 className={styles.title}>{title}</h2>
            <div className={styles.columns}>
                <FaqColumn data={leftColumn} />
                <FaqColumn data={rightColumn} />
            </div>
        </div>
    );
}

export default Faq;